// Sorting for DataTable: by one column's value, ascending or descending; ties keep their order.
export type SortDir = "asc" | "desc";
export type SortValue = number | string;

export interface SortState {
  key: string;
  dir: SortDir;
}

export function sortRows<T>(rows: readonly T[], value: (row: T) => SortValue, dir: SortDir): T[] {
  const sign = dir === "asc" ? 1 : -1;
  return [...rows].sort((a, b) => {
    const x = value(a);
    const y = value(b);
    const c = typeof x === "number" && typeof y === "number" ? x - y : String(x).localeCompare(String(y));
    return sign * c;
  });
}

/** A click on a column: the same column flips, a new one starts descending for numbers. */
export function nextSort(current: SortState | undefined, key: string, numeric: boolean): SortState {
  if (current?.key === key) return { key, dir: current.dir === "asc" ? "desc" : "asc" };
  return { key, dir: numeric ? "desc" : "asc" };
}
